<template>
  <component
    :is="url ? 'a' : 'div'"
    :href="url"
    target="_blank"
    class="relative bg-gray-100"
    :class="{
      'cursor-pointer': note !== null,
    }"
    style="padding-bottom: 66.666667%"
    v-on="conditionalClick"
  >
    <img v-if="cover" :src="cover" class="absolute w-full h-full object-cover" />
    <div v-else class="absolute w-full h-full inline-flex items-center justify-center">
      <div class="flex flex-col items-center space-y-4">
        <svg viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12 text-gray-600">
          <path
            v-if="note"
            fill="currentColor"
            class="text-yellow-600"
            d="M21 15l-6 5.996L4.002 21A.998.998 0 0 1 3 20.007V3.993C3
            3.445 3.445 3 3.993 3h16.014c.548 0 .993.456.993 1.002V15zM19
            5H5v14h8v-5a1 1 0 0 1 .883-.993L14 13l5-.001V5zm-.829
            9.999L15 15v3.169l3.171-3.17z"
          />
          <path
            v-else-if="link"
            d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1
            1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793
            7.794-1.414-1.414L17.585 5H13V3h8z"
          />
          <path
            v-else-if="isPDF"
            fill="currentColor"
            class="text-red-600"
            d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9
            2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5
            1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67
            1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5
            1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4
            6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
          />
          <path
            v-else-if="isVideo"
            fill="currentColor"
            class="text-indigo-600"
            d="M12 20h8v2h-8C6.477 22 2 17.523 2 12S6.477 2
            12 2s10 4.477 10 10a9.956 9.956 0 0 1-2 6h-2.708A8
            8 0 1 0 12 20zm0-10a2 2 0 1 1 0-4 2 2 0 0 1 0
            4zm-4 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm8 0a2 2
            0 1 1 0-4 2 2 0 0 1 0 4zm-4 4a2 2 0 1 1 0-4
            2 2 0 0 1 0 4z"
          />
          <path
            v-else
            d="M12 16H8V8h4a4 4 0 1 1 0 8zm-2-6v4h2a2 2 0 1 0
            0-4h-2zm5-6H5v16h14V8h-4V4zM3 2.992C3 2.444 3.447
            2 3.999 2H16l5 5v13.993A1 1 0 0 1 20.007 22H3.993A1
            1 0 0 1 3 21.008V2.992z"
          />
        </svg>
        <p class="text-gray-900">No preview available</p>
      </div>
    </div>
    <slot />
  </component>
</template>

<script>
import ProjectAssetTileApprovalStatus from './ProjectAssetTileApprovalStatus.vue';

export default {
  components: {
    ProjectAssetTileApprovalStatus,
  },
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  computed: {
    conditionalClick() {
      if (this.url || this.link) return {};

      return {
        click: () => {
          this.$emit('view-note', this.projectAsset);
        },
      };
    },
    media() {
      if (!this.asset?.media) {
        return null;
      }

      return this.$store.state.entities.media.byId[this.asset.media];
    },
    isPDF() {
      return this.media && this.media.mimeType && this.media.mimeType === 'application/pdf';
    },
    isVideo() {
      return this.media && this.media.mimeType && this.media.mimeType.includes('video/');
    },
    link() {
      if (!this?.asset?.link) {
        return null;
      }

      return this.$store.state.entities.links.byId[this.asset.link];
    },
    note() {
      if (!this?.asset?.note) {
        return null;
      }

      return this.$store.state.entities.notes.byId[this.asset.note];
    },
    url() {
      if (this.media) {
        return this.media.url;
      }

      if (this.link) {
        return this.link.url;
      }

      return '';
    },
    cover() {
      if (this.media && this.media.mimeType && this.media.mimeType.indexOf('image') === 0) {
        return this.media.url;
      }

      if (this.link && this.link.cover) {
        return this.link.cover;
      }

      return null;
    },
  },
};
</script>
